import { useTranslation } from "react-i18next";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PageHeader from "@/components/feature/PageHeader";
import { img } from "@/lib/images";
import { LocalizedLink } from "@/i18n/language";

type PrivacySection = {
  titleKey: string;
  paragraphKeys: string[];
};

const sections: PrivacySection[] = [
  {
    titleKey: "privacy_sec1_title",
    paragraphKeys: ["privacy_sec1_p1", "privacy_sec1_p2", "privacy_sec1_p3"],
  },
  {
    titleKey: "privacy_sec4_title",
    paragraphKeys: ["privacy_sec4_p1", "privacy_sec4_p2", "privacy_sec4_p3"],
  },
  {
    titleKey: "privacy_sec5_title",
    paragraphKeys: ["privacy_sec5_p1", "privacy_sec5_p2", "privacy_sec5_p3"],
  },
  {
    titleKey: "privacy_sec6_title",
    paragraphKeys: ["privacy_sec6_p1", "privacy_sec6_p2"],
  },
  {
    titleKey: "privacy_sec7_title",
    paragraphKeys: ["privacy_sec7_p1", "privacy_sec7_p2"],
  },
  {
    titleKey: "privacy_sec2_title",
    paragraphKeys: ["privacy_sec2_sub_text"],
  },
  {
    titleKey: "privacy_sec3_title",
    paragraphKeys: ["privacy_sec3_p1"],
  },
];

export default function PrivacyPage() {
  const { t } = useTranslation();

  return (
    <div className="bg-background-50 text-foreground-950 min-h-screen">
      <Navbar />
      <main>
        <PageHeader
          eyebrow={t("privacy_eyebrow")}
          title={t("privacy_title")}
          subtitle={t("privacy_intro")}
          image={img("legal-pages/header-legal-01.jpg")}
          imageAlt="Privacy Policy Bali VW Tour"
        />

        <section className="py-12 md:py-16 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-8">
            {/* Last updated */}
            <div className="flex items-center gap-2 mb-6 text-sm text-foreground-600">
              <span className="w-5 h-5 flex items-center justify-center text-accent-700">
                <i className="ri-calendar-check-line text-base"></i>
              </span>
              <span>{t("privacy_updated")}</span>
            </div>

            <div className="space-y-6">
              {sections.map((section) => (
                <div
                  key={section.titleKey}
                  className="bg-background-100 border border-background-200 rounded-lg p-6 md:p-8"
                >
                  <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
                    {t(section.titleKey)}
                  </h2>
                  <div className="w-10 h-0.5 bg-accent-500 mb-4"></div>
                  <div className="space-y-4 text-foreground-700 leading-relaxed text-sm md:text-base">
                    {section.paragraphKeys.map((key) => (
                      <p key={key}>{t(key)}</p>
                    ))}
                  </div>
                </div>
              ))}

              <div className="bg-secondary-50 border border-secondary-200 rounded-lg p-6 md:p-8 flex flex-col sm:flex-row sm:items-center gap-4">
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-900 text-xl flex-shrink-0">
                  <i className="ri-file-text-line"></i>
                </span>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                  {t("privacy_terms_note")}{" "}
                  <LocalizedLink to="/impressum" className="text-primary-600 font-medium underline underline-offset-2 hover:text-primary-700 cursor-pointer">
                    {t("privacy_terms_link")}
                  </LocalizedLink>
                </p>
              </div>

              <div className="text-xs text-foreground-500 pt-4">
                {t("privacy_source")}
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}